import $services from "../services";
import Form from "../models/form.model";
import Consumer from "@/models/consumer.model";
import Customer from "@/models/customer.model";

export default {
    namespaced: true,
    state: {
        form: new Form(),
        consumer: null,
        account: null,
        code: null,
        accountSetting: null,
        reply: {},
        replied_at: null,
        session_key: null,
        session_token: null,
        appointment: null,
        contactDetails: new Customer()
    },
    getters: {
        getForm: state => state.form,
        getConsumer: state => state.consumer,
        getAccount: state => state.account,
        getCode: state => state.code,
        getAccountSetting: state => state.accountSetting,
        getReply: state => state.reply,
        getRepliedAt: state => state.replied_at,
        getSessionKey: state => state.session_key,
        getSessionToken: state => state.session_token,
        getAppointment: state => state.appointment,
        getContactDetails: state => new Customer(state.contactDetails),

    },
    mutations: {
        setForm: (state, payload) => state.form = payload,
        setConsumer: (state, payload) => state.consumer = payload,
        setAccount: (state, payload) => state.account = payload,
        setCode: (state, payload) => state.code = payload,
        setAccountSetting: (state, payload) => state.accountSetting = payload,
        setReply: (state, payload) => state.reply = payload,
        setRepliedAt: (state, payload) => state.replied_at = payload,
        setSessionKey: (state, payload) => state.session_key = payload,
        setSessionToken: (state, payload) => state.session_token = payload,
        setAppointment: (state, payload) => state.appointment = payload,
        setContactDetails: (state, payload) => state.contactDetails = payload,
    },
    actions: {
        async loadFormByLink(context, {linkHash, request, consumer}) {
            const form = await $services.forms.getFormByLink(linkHash, request, consumer);
            context.commit('setForm', new Form(form.data.data));
            context.commit('setConsumer', new Consumer(form.data.consumer));
            if (form.data.account_id) {
                context.commit('setAccount', form.data.account_id);
            }
            if (form.data.contact_details) {
                context.commit('setContactDetails', form.data.contact_details);
            }
            if (form.data.code) {
                context.commit('setCode', form.data.code);
            }
            if (form.data.account_setting) {
                context.commit('setAccountSetting', form.data.account_setting);
            }
            if (form.data.session_key) {
                context.commit('setSessionKey', form.data.session_key)
            }
            if (form.data.session_token) {
                context.commit('setSessionToken', form.data.session_token)
            }
            if (form.data.appointment) {
                context.commit('setAppointment', form.data.appointment)
            }
        },
        async loadFormByCode(context, code) {
            const form = await $services.forms.getFormByCode(code);
            context.commit('setForm', form.data.data);
            context.commit('setConsumer', new Consumer(form.data.consumer));
            if (form.data.account_id) {
                context.commit('setAccount', form.data.account_id);
            }
            if (form.data.contact_details) {
                context.commit('setContactDetails', form.data.contact_details);
            }
            if (form.data.code) {
                context.commit('setCode', form.data.code);
            }
            if (form.data.account_setting) {
                context.commit('setAccountSetting', form.data.account_setting);
            }
            if (form.data.session_key) {
                context.commit('setSessionKey', form.data.session_key)
            }
            if (form.data.session_token) {
                context.commit('setSessionToken', form.data.session_token)
            }
            if (form.data.appointment) {
                context.commit('setAppointment', form.data.appointment)
            }
        },
        async loadForPreview(context, formId) {
            const form = await $services.forms.getForPreview(formId);
            context.commit('setForm', form.data.data);
            context.commit('setConsumer', new Consumer(form.data.consumer));
            if (form.data.account_id) {
                context.commit('setAccount', form.data.account_id);
            }
            if (form.data.account_setting) {
                context.commit('setAccountSetting', form.data.account_setting);
            }
            if (form.data.appointment) {
                context.commit('setAppointment', form.data.appointment)
            }
        },
        async loadReply(context, replyId) {
            const reply = await $services.reply.getReply(replyId);
            context.commit('setConsumer', new Consumer(reply.data.consumer));
            if (reply.data.data) {
                context.commit('setReply', reply.data.data);
            }
            if (reply.data.form) {
                context.commit('setForm', reply.data.form);
            }
            if (reply.data.account_setting) {
                context.commit('setAccountSetting', reply.data.account_setting);
            }
            if (reply.data.replied_at) {
                context.commit('setRepliedAt', reply.data.replied_at);
            }
        }
    }
}